import { authStore } from 'stores';
import { useEffect } from 'react';

export const useClarity = () => {
	const currentUser = authStore.user;
	const clarityProjectId = process.env['NEXT_PUBLIC_CLARITY_PROJECT_ID'];

	useEffect(() => {
		if (clarityProjectId) {
			import('@microsoft/clarity').then((clarity) => {
				clarity.default.init(clarityProjectId);
				console.info('Clarity initialized successfully');
			});
		}

		if (currentUser && clarityProjectId) {
			import('@microsoft/clarity').then((clarity) => {
				clarity.default.identify(currentUser.id, undefined, undefined, currentUser.fullName);
				console.info('Clarity userId set successfully');
			});
		}
	}, [currentUser, clarityProjectId]);
};
